<div style="padding-bottom: 5px;" 
*ngIf="prescriptionRequired" fxLayout="row" fxLayoutAlign="start center">
    <img height="40" class="img45" src="assets/images/rx.svg" alt="Prescription Required">
    <span style="
    font-weight: 500;"> Prescription Required</span>

  </div>

  <div class="py-1 lh brand">
    <p *ngIf="product?.additionalSpec?.Author?.length>0">
      <span class="text-muted fw-500">Author:
      </span>
      <a class="emi pointer" (click)="brand(product?.additionalSpec.Author)">
        <span>{{ product?.additionalSpec.Author }}</span>
      </a>
    </p>

    <P *ngIf="MANUFACTURER!=null">
      <span class="text-muted fw-500">MANUFACTURER/ MARKETER
      </span>
        <span Style="color:black"><br>{{ MANUFACTURER }}</span>

    </P>

    <P *ngIf="SALTCOMPOSITION!=null">
      <span class="text-muted fw-500">SALTCOMPOSITION:
      </span>
        <span Style="color:black"> <br>{{ SALTCOMPOSITION }}</span>         
    </P>

    <P *ngIf="STORAGES!=null">
      <span class="text-muted fw-500">STORAGES:
      </span>
        <span Style="color:black"> <br>{{ STORAGES }}</span>
    </P>
    <P *ngIf="product?.additionalSpec?.Brands?.length>0">
      <span class="text-muted fw-500">Brands:
      </span>
      <a class="emi pointer" (click)="brand(product?.additionalSpec.Brands)">
        <span>{{ product?.additionalSpec.Brands }}</span>
      </a>
    </P>

<span *ngIf="product.type!='Variants' && product.type!='Configurable'">
  <div class="cursor-text" 
    *ngIf="((product.qty <= 0||product.isInStock==0) && 
    (product.manageStock == 1||product.isInStock==0)) else conditionalBlock">
    <div class="cursor-text"  >
      <div class="padding-l10 cursor-text" fxLayout="row"
        fxLayoutGap="5px">
        <span>Availability: <span class="colorRed">
          Unavailable</span></span>
      </div>
      </div>
      <ng-template #conditionalBlock1>
        <div class="padding-l10 cursor-text" fxLayout="row" fxLayoutGap="3px">
          <span>Availability</span>

          <span class="color468">
            In Stock</span>
        </div>
      </ng-template>

    </div>
    <ng-template #conditionalBlock>
      <div class="cursor-text" class="padding-l10" fxLayout="row" fxLayoutGap="3px">
        <span>Availability</span>

        <span class="color468">
          In Stock</span>
      </div>
    </ng-template>
</span>
  
<span  *ngIf="product.type=='Variants' || product.type=='Configurable'">
  
  <div class="cursor-text" 


    *ngIf="!((qty>0 && isInStock==1)||(manageStock==0));  else conditionalBlock">
    <div class="cursor-text"  >
      <div class="padding-l10 cursor-text" fxLayout="row"
        fxLayoutGap="5px">
        <span>Availability: <span class="colorRed">
          Unavailable</span></span>
      </div>
      </div>
      <ng-template #conditionalBlock1>
        <div class="padding-l10 cursor-text" fxLayout="row" fxLayoutGap="3px">
          <span>Availability</span>

          <span class="color468">
            In Stock</span>
        </div>
      </ng-template>

    </div>
    <ng-template #conditionalBlock>
      <div class="cursor-text" class="padding-l10" fxLayout="row" fxLayoutGap="3px">
        <span>Availability</span>

        <span class="color468">
          In Stock</span>
      </div>
    </ng-template>
</span>

  </div>